/**
 * @name 表单属性设置
 * @author liuguisheng
 * @version 2019-09-24
 * 
*/

export const formConfig = [
    'setting-component-size', // 组件尺寸
]




// WEBPACK FOOTER //
// ./src/assets/js/form_config.js